<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'password',
})
</script>
<template>
  <a-modal v-model:open="opend" width="50%" title="帐号安全" @ok="submit">
    <div class="padding">
      <a-steps :current="current" :items="stepItems" />
    </div>
    <div style="padding:50px 100px;margin:auto;">
       <a-input v-if="current==0" placeholder="原密码..." :max-length="16" v-model:value="pwd.oldpasswd"></a-input>
        <a-input v-else-if="current==1" placeholder="新密码" :max-length="16" v-model:value="pwd.passwd"></a-input>
        <a-input v-else  placeholder="确认新密码" :max-length="16" v-model:value="pwd.repasswd"></a-input>
    </div>
    <div class="padding text-center">
      <a-button-group>
        <a-button type="primary" @click="currentChange(false)" :disabled="current==0"><LeftOutlined /></a-button>
        <a-button type="primary" @click="currentChange(true)"  :disabled="current==2"><RightOutlined /></a-button>
      </a-button-group>
    </div>
  </a-modal>
</template>
<script setup lang="ts" name="password">
import { reactive,ref,defineExpose } from 'vue'
import {message} from 'ant-design-vue'
import api from '@/utils/http/service'
import {LeftOutlined,RightOutlined} from '@ant-design/icons-vue'

  const stepItems= reactive<Array>([
      {
        title: '请输入原密码',
        description:'若忘记密码，请联系管理员重置密码',
      },
      {
        title: '请输入新密码',
        description:'长度至少6位数字与字母组合',
        subTitle: 'Left 00:00:08',
      },
      {
        title: '请确认新密码',
        description:'请再次输入新密码',
      },
    ])
  const current=ref<Number>(0)
  let pwd=reactive<Object>({
    oldpasswd:'',
    passwd:'',
    repasswd:''
  })
  const opend=ref<boolean>(false)
  const open=():void=>{
    opend.value=true
  }
  const currentChange=(b:Boolean)=>{

    if(b&&current.value<2){
      current.value++
    }else if(current.value>0){
      current.value--
    }
  }
  const submit=():void=>{
      if(!pwd.oldpasswd){
          message.error('旧密码不可为空')
          current.value=1
          return false
      }

      if(!pwd.passwd){
          message.error('新密码不可为空')
          current.value=1
          return false
      }
      if(pwd.passwd.length<6){
          message.error('密码至少需要6位字母与数字组合')
          current.value=1
          return false
      }
      if(!pwd.repasswd){
          message.error('请输入确认密码')
          current.value=2
          return false
      }
      if(pwd.passwd!=pwd.repasswd){
          message.error('两次密码输入不一致，请再次输入确认密码')
          current.value=2
          return false
      }
      api.user.changepassword(pwd).then(res=>{
        if(res.state==1){
          message.success('密码修改成功，请妥善保管您的密码')
          opend.value=false
        }else{
          message.error(res.message)
          current.value=0
        }
      })
  }
  defineExpose({open})
</script>
